import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import MusicForm from './MusicForm';

function MusicView() {
  const [musicList, setMusicList] = useState([]);
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    const fetchMusic = async () => {
      const res = await fetch('/api/music', {
        headers: { 'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json' }
      });
      if (res.ok) {
        const data = await res.json();
        setMusicList(data);
      }
    };
    fetchMusic();
  }, [token]);

  return (
    <div className="music-view">
      <h2>🎶 Music</h2>
      <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead style={{ backgroundColor: '#f2f2f2' }}>
          <tr>
            <th>ID</th>
            <th>Music Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {musicList.map(m => (
            <tr key={m.music_id}>
              <td>{m.music_id}</td>
              <td>{m.music_name}</td>
              <td>
                <Link to={`/dashboard/music/edit/${m.music_id}`}><button>Edit</button></Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Link to="/dashboard/music/add"><button style={{ marginTop: '10px' }}>Add Music</button></Link>
    </div>
  );
}

export default MusicView;
